<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "HFooter",
  data() {
    return {};
  },
  create() {},
  mounted() {},
};
</script>




<style>
/* search 页面 */
.el-cascader-menu__wrap {
  height: 300px !important;
}
.citypanel {
  border: none !important;
}
.el-cascader-node {
  width: 140px !important;
}

.search-bar-cities {
  min-width: 300px;
}
/* .search-bar-cities .el-cascader__tags .el-tag {
  display: none;
} */
/* 评估界面 */
/* .assess-content-title {
  font-weight: 700;
  font-size: 1.2em;
  padding-top: 20px;
} */

body {
  margin: 0;
  /* overflow-x: hidden; */
  font-family: "微软雅黑";
  min-width: 720px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-width: 540px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-align: center;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;

  /* padding: 0 20px; */
}

.anchorBL {
  display: none;
}

/* 表格居中 */
body .el-table th,
body .el-table td {
  text-align: center !important;
}

.textAlignLeft {
  text-align: left !important;
}

.marginZero {
  margin: 0 !important;
}

.padding20 {
  padding: 20px !important;
}
.bggrey {
  background-color: rgb(0, 0, 0, 0.02) !important;
}
.bghover:hover {
  box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.02);
}

.paddingTop20 {
  padding-top: 20px !important;
}

.paddingBottom20 {
  padding-bottom: 20px !important;
}
.paddingLeftRight {
  padding-left: 20px;
  padding-right: 20px;
}
.paddingBottom20 {
  padding-bottom: 20px !important;
}
.paddingTwoColumns {
  padding-top: 0px;
  padding-bottom: 20px;
}

/* 去掉高德地图水印 */
.amap-logo {
  display: none !important;
}
.amap-copyright {
  display: none !important;
}
</style>
